import type { Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { COMMISSIONING_POLLING } from '~/constants/commissioningPolling'
import { queryKeys } from '~/queryClient'
import { fetchCommissioningStatus } from '~/services-v2/financial-bff/commissioning-status.gql'

export default function useCommissioningStatus(
  installationId: Ref<string | undefined>,
  options?: { enabled?: Ref<boolean>, refetchInterval?: Ref<number> },
) {
  const enabled = computed(() => {
    const extraEnabled = options?.enabled?.value ?? true
    return extraEnabled && Boolean(installationId.value)
  })

  const refetchInterval = computed(() =>
    options?.refetchInterval?.value ?? COMMISSIONING_POLLING.REFETCH_INTERVAL_MS,
  )

  return useQuery({
    queryKey: computed(() => queryKeys.INSTALLATION.COMMISSIONING_STATUS(installationId.value as string)),
    enabled,
    queryFn: () => fetchCommissioningStatus({ installation_id: installationId.value! }),
    refetchInterval,
  })
}
